
var Mediator = require('./Mediator.js');
var MOUSE_STATE = {'DOWN': 'down', 'MOVE': 'move', 'RELEASE': 'release'};

/**
 * 管理批注过程中各种绘制及编辑的事件
 */
var Events = {

  flags: {
    canvasPressed: false,
    pointPressed: false,
    layerPressed: false,

    isMove: false,
    onLayer: false,
  },

  data: {
    lastPointX: -1,
    lastPointY: -1,
    lastLayerX: -1,
    lastLayerY: -1,

    currentCid: -1,
    checkedPoint: null,
    keyEvents: [],
    documentClickHandlers: [],
    delayInit: null,
  },

  initFlags: function() {
    Events.flags.canvasPressed = false;
    Events.flags.pointPressed = false;
    Events.flags.layerPressed = false;

    Events.flags.isMove = false;
    Events.flags.isEditMode = false;
  },

  execDelay: function() {
    if(Events.data.delayInit && Events.flags.canvasPressed) {        //延迟初始化
      Events.data.delayInit();
      Events.data.delayInit = null;
    }
  },

  canvasMouseDown: function(e) {
    if(e.button !== 0) {
      return;
    }
    if(!Events.flags.canvasPressed) {

      Events.checkArrowClick.call(this, e);

      //做好绘制准备
      Events.flags.canvasPressed = true;
      Mediator.addNewLayer(e, this, MOUSE_STATE.DOWN);
      //延迟初始化，根据isEditMode值决定是否调用，且只调用一次（调用完后置空）
      Events.data.delayInit = function() {
        Mediator.reset();
        Mediator.setState({isShowStylePicker: false});
      }
    }
  },
  canvasMouseMove: function(e) {

    if(!Events.flags.canvasPressed) {
      //切入扩大箭头选择
      if(Events.checkArrowMove.call(this, e)) {
        return;
      }
      if(!Events.flags.onLayer) {
        $(Mediator.getCanvas()).css( {
          cursor: "crosshair"
        } );
      }
      Events.flags.onLayer = false;
    }
    //Mediator.getCanvas().style.cursor = 'crosshair';

    if(Events.flags.isEditMode) {
      Events.editMouseMove.call(this, e);
    } else {
      Events.execDelay();
      Events.drawMouseMove.call(this, e);
    }

    e.stopPropagation();
    e.preventDefault();
    return false;
  },
  canvasMouseUp: function(e) {
    if(Events.flags.isEditMode) {
      Events.editMouseUp.call(this, e);
    } else {
      Events.execDelay();
      Events.drawMouseUp.call(this, e);
    }
    Events.initFlags();
  } ,

  drawUpWithText: function (e) {
    if(Events.flags.isEditMode) {
      Events.editMouseUp.call(this, e);
    } else {
      Events.execDelay();
      Events.drawMouseUp.call(this, e);
      Mediator.openTextArea();
    }
    Events.initFlags();
  },

  drawMouseMove: function (e) {
    if (Events.flags.canvasPressed) {
      Events.data.currentCid = Mediator.replaceOldLayer(e, this, MOUSE_STATE.MOVE);
    }
  },
  drawMouseUp: function (e) {
    if (Events.flags.canvasPressed) {
      Events.data.currentCid = Mediator.replaceOldLayer(e, this, MOUSE_STATE.RELEASE);
      //绘画完成后，产出新数据，默认选中并做保存
      if(Events.data.currentCid !== -1) {
        Mediator.switchToEdit();
        Mediator.restore();
      }
    }
  },

  //暂时写成这样，特殊处理箭头和选择点
  checkArrowMove: function(e) {
    var x = e.pageX - $(this).offset().left + Mediator.reactComp.scrollLeft;
    var y = e.pageY - $(this).offset().top + Mediator.reactComp.scrollTop;

    var layer = Mediator.isOnArrow(x, y);
    if(layer !== null) {
      Mediator.resetEvents();
      $(Mediator.getCanvas()).triggerLayerEvent(layer, 'mousemove');
      //Events.layerMouseMove();
      return true;
    }
  },

  //暂时写成这样，特殊处理箭头和选择点
  checkArrowClick: function(e) {
    var x = e.pageX - $(this).offset().left + Mediator.reactComp.scrollLeft;
    var y = e.pageY - $(this).offset().top + Mediator.reactComp.scrollTop;

    var layer = Mediator.isOnArrow(x, y);
    if(layer !== null) {
      $(Mediator.getCanvas()).triggerLayerEvent(layer, 'mousedown');
    }
  },

  editMouseMove: function (e) {
    var x = e.pageX - $(this).offset().left + Mediator.reactComp.scrollLeft;
    var y = e.pageY - $(this).offset().top + Mediator.reactComp.scrollTop;

    //鼠标按下图层后，实现拖拽
    if (Events.flags.layerPressed) {
      var dx = x - Events.data.lastLayerX;
      var dy = y - Events.data.lastLayerY;
      if(dx === 0 && dy === 0) {
        return;
      }
      Events.flags.isMove = true;
      Events.data.lastLayerX = x;
      Events.data.lastLayerY = y;
      Mediator.doMoveLayer(dx, dy);
      return;
    }
    //鼠标按下选择点后，拖动改变边框
    if (Events.flags.pointPressed) {
      var dx = x - Events.data.lastPointX;
      var dy = y - Events.data.lastPointY;
      if(dx === 0 && dy === 0) {
        return;
      }
      Events.data.lastPointX = x;
      Events.data.lastPointY = y;

      //拖拽边框将图层缩小到最小值后，不再拖动
      var isDraged = Mediator.doDragBorder(dx, dy, x, y);
      if(!Events.flags.isMoved && isDraged) {
        Events.flags.isMove = true;
      }
      return;
    }
  },
  editMouseUp: function (e) {
    //按下图层或选择点移动，必然导致数据改变，做保存
    if ((Events.flags.layerPressed || Events.flags.pointPressed) && Events.flags.isMove) {
      Mediator.restore();
      Events.flags.isMove = false;
    }
  },

  layerMouseDown: function (layer) {
    if(layer.event.button !== 0) {
      return;
    }
    Mediator.reset();
    Events.data.currentCid = layer.data.cid;
    Mediator.loadCheckPoint();
    Events.flags.layerPressed = true;
    Events.data.lastLayerX = layer.eventX + Mediator.reactComp.scrollLeft;
    Events.data.lastLayerY = layer.eventY + Mediator.reactComp.scrollTop;
    Events.flags.isEditMode = true;
  },
  layerMouseMove: function (layer) {
    $(Mediator.getCanvas()).css( {
      cursor: "move"
    } );
    Events.flags.onLayer = true;
  },
  layerDblClick: function (layer) {
    Mediator.openTextArea();
  },


  pointMouseDown: function (layer) {
    if(layer.event.button !== 0) {
      return;
    }
    Events.flags.pointPressed = true;
    Events.data.checkedPoint = layer;
    Events.data.lastPointX = layer.eventX + Mediator.reactComp.scrollLeft;
    Events.data.lastPointY = layer.eventY + Mediator.reactComp.scrollTop;
    Events.flags.isEditMode = true;
  },
  pointMouseMove: function (layer) {
    Mediator.getCanvas().style.cursor = Mediator.getCursorStyle(layer);
  },

  registKeyEvent: function(code, func, combo) {
    var events = Events.data.keyEvents;
    for(var i=0;i<events.length;i++) {
      var event = Events.data.keyEvents[i];
      if(event.code === code && event.combo === combo) {
        event.func = func;
        return;
      }
    }
    events.push({code: code, func: func, combo: combo});
    Events.setKeyEvents();
  },
  clearKeyEvents: function() {
    Events.data.keyEvents = [];
  },
  setKeyEvents: function () {
    window.onkeydown = function (event) {
      if(Events.flags.canvasPressed || Events.flags.layerPressed || Events.flags.pointPressed) {
        return;
      }
      var e = event?event:window.event;
      var keyEvents = Events.data.keyEvents;
      for(var i=0;i<keyEvents.length;i++) {
        var keyEvent = keyEvents[i];
        if(keyEvent.code === e.keyCode) {
          if(!keyEvent.combo || (keyEvent.combo && e[keyEvent.combo])) {
            keyEvent.func();
          }
        }
      }
    };
  },
};

module.exports = Events;


// WEBPACK FOOTER //
// ./src/helper/Review/PaintEvents.js